import { ChangeEvent } from 'react';

import { RadioGroup, TextField } from '@atom/mui';
import colors from '@atom/styles/colors';
import { isValidUrl } from '@atom/utilities/validationUtilities';

import classes from '../formBuilder.module.css';

const { RadioButton } = RadioGroup;

export interface Props {
  title: string;
  url: string;
  width: number;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const styles = {
  radioGroup: {
    display: 'flex',
    alignItems: 'center',
  },
  radio: {
    width: 'inherit',
    marginRight: '16px',
  },
  iframeContainer: {
    position: 'relative',
    paddingBottom: '56.25%',
    paddingTop: '2.5rem',
    height: 0,
    marginBottom: '3rem',
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: `1px solid ${colors.neutral.ash}`,
  },
};

const WIDTH_OPTIONS = [
  { value: 33, label: 'Small' },
  { value: 50, label: 'Medium' },
  { value: 100, label: 'Large' },
];

const IFrameInput = ({ title, url, width, onChange }: Props) => {
  const handleWidthChange = (event: any, value: string) => {
    onChange({
      ...event,
      target: {
        name: 'width',
        value,
      },
    });
  };

  return (
    <>
      <div className={classes.multiInputContainer}>
        <div className={classes.doubleInput}>
          <TextField
            variant="standard"
            value={title}
            onChange={onChange}
            name="title"
            label="Title"
          />
        </div>
        <div className={classes.doubleInput}>
          <TextField
            variant="standard"
            value={url}
            onChange={onChange}
            name="url"
            label="Embed URL"
          />
        </div>
      </div>
      <div className={classes.iframeSizeContainer}>
        <div className={classes.iframeSizeLabel}>Size:</div>
        <RadioGroup
          row
          name="width"
          defaultValue={width}
          onChange={handleWidthChange}
          sx={styles.radioGroup}
        >
          {WIDTH_OPTIONS.map(option => (
            <RadioButton
              key={option.value}
              value={option.value.toString()}
              label={option.label}
              sx={styles.radio}
            />
          ))}
        </RadioGroup>
      </div>
      <div className={classes.iframePreview}>
        <div style={{ width: `${width || 100}%` }}>
          <div style={styles.iframeContainer}>
            {isValidUrl(url) ? (
              <iframe style={styles.iframe} src={url} frameBorder={0} />
            ) : (
              <div
                style={{ ...styles.iframe, background: colors.neutral.ash }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default IFrameInput;
